import React from "react";
import EmployeeDashboard from "./Dashbaord/EmployeeDashboard";
import ManagerMyInfo from "./Manager/ManagerMyInfo";
import ManagerDashboard from "./Dashbaord/ManagerDashboard";

export default function HRMSEmployeeHome() {
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const role = user.role || "Employee";

  if (role === "Manager") {
    return <ManagerDashboard />;
  }

  // return <EmployeeDashboard />;
  return <ManagerMyInfo />;
}
